import {Pagination, PaginationParams, SimpleSearchPaginationParams} from "../core/services/utils";
import {http} from "../core/services/http";
import {IBook, INameId} from "../core/interfaces";
import {UUID} from "node:crypto";


export const getAllIllustrators = (params?: SimpleSearchPaginationParams) =>
    http.get<Pagination<INameId>>('/api/dashboard/illustrators', {
        params,
    })

export const createIllustrator = (data: INameId) =>
    http.post<INameId>('/api/dashboard/illustrators', data)

export const updateIllustrator  = (id: UUID, data: INameId) =>
    http.put<INameId>(`/api/dashboard/illustrators/${id}`,  data )

export const deleteIllustrator  = (id: UUID) =>
    http.delete(`/api/dashboard/illustrators/${id}`, {})